import React, { useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { ObjectOfAny, QuestionSchema } from '../../reducers/types';
import { useSelector } from 'react-redux';
import questionGroupStepProjections from '../../projections/questionGroupStep';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';

export const useChildQuestions = (props: ChildQuestionsProps) => {
    const { question, questions } = props;
    // in claim form when a claim is draft there is
    // a scenario that a question can be triggered by question groupstep that is not fetched yet
    const answerFromGroupSteps = useSelector(
        questionGroupStepProjections.answerFromGroupSteps,
    );

    const { values, setFieldValue }: any = useFormikContext();
    let findParentQuestion = useMemo(
        () =>
            questions.find(
                (item: { id: string }) =>
                    item.id === question.enabledByQuestionId,
            ),
        [questions, question],
    );
    if (!findParentQuestion && answerFromGroupSteps.length > 0) {
        const findAnswerQuestion = answerFromGroupSteps.find(
            (item: { questionCode: string; questionId: string }) =>
                item.questionId === question.enabledByQuestionId,
        );
        if (findAnswerQuestion) {
            // @ts-ignore
            findParentQuestion = {};
            // @ts-ignore
            findParentQuestion.code = findAnswerQuestion.questionCode;
            // @ts-ignore
            findParentQuestion.id = findAnswerQuestion.questionId;
        }
    }
    const isEnabledByOptionType =
        question.enabledByQuestionId === findParentQuestion?.id &&
        findParentQuestion &&
        values[findParentQuestion?.code] != null &&
        values[findParentQuestion?.code] === question.enabledByOptionId;

    const isEnabledByCheckBoxType =
        GENERAL_FUNCTIONS.checkIfParentQuestionCheckboxTickedToEnableQuestion(
            findParentQuestion,
            values,
        );

    const isEnabledQuestion = isEnabledByOptionType || isEnabledByCheckBoxType;

    //Clear field value if parent question is not selected (includes all options)
    const shouldClearFieldValue =
        (question.enabledByOptionId &&
            question.enabledByQuestionId === findParentQuestion?.id &&
            findParentQuestion &&
            values[findParentQuestion?.code] !== question.enabledByOptionId) ||
        GENERAL_FUNCTIONS.checkIfParentQuestionCheckboxUntickedToClearChildQuestionValue(
            findParentQuestion,
            values,
        );

    useEffect(() => {
        if (shouldClearFieldValue) {
            setFieldValue(question.code, undefined);
        }
    }, [shouldClearFieldValue]);

    return {
        isEnabledQuestion,
    };
};

const GenericChildQuestions = (
    props: any & { children: React.ReactNode },
): JSX.Element | null => {
    const { isEnabledQuestion } = useChildQuestions(props);

    return <>{isEnabledQuestion ? <>{props.children}</> : null}</>;
};

type ChildQuestionsProps = {
    question: QuestionSchema;
    questions: QuestionSchema[];
};

export default GenericChildQuestions;
